import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';

interface DropIndicatorProps {
  id: string;
  isVisible: boolean;
}

export function DropIndicator({ id, isVisible }: DropIndicatorProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  if (!isVisible) return null;

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'h-12 mx-3 rounded-lg transition-all duration-200 flex items-center justify-center',
        isOver ? 'bg-primary/10 border-primary' : 'bg-transparent border-border',
        'border-2 border-dashed'
      )}
    >
      {isOver && (
        <span className="text-xs text-primary font-medium">
          Drop here to add to favorites
        </span>
      )}
    </div>
  );
}
